import { render, staticRenderFns } from "./Tech-output.vue?vue&type=template&id=29e7d152&scoped=true&"
import script from "./Tech-output.vue?vue&type=script&lang=js&"
export * from "./Tech-output.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e7d152",
  null
  
)

export default component.exports